import React from 'react'
import { Box, Group, Badge, Text, ActionIcon, Stack } from '@mantine/core'
import { FiX } from 'react-icons/fi'

interface SlopFeedFilterPanelProps {
  firearmName: string | null;
  onClearFilter: () => void;
}

export const SlopFeedFilterPanel: React.FC<SlopFeedFilterPanelProps> = ({ firearmName, onClearFilter }) => {
  if (!firearmName) return null;

  return (
    <Box
      sx={{
        backgroundColor: 'var(--gs-surface2)',
        border: '1px solid var(--gs-border)',
        borderRadius: 8,
        padding: '12px',
        marginBottom: '16px',
        borderLeft: '3px solid #E85D04'
      }}
    >
      <Stack spacing={8}>
        <Group spacing="xs" position="apart">
          <Badge size="sm" variant="light" color="orange">
            FILTERING BY
          </Badge>
          <ActionIcon size="xs" variant="subtle" color="gray" onClick={onClearFilter}>
            <FiX size={16} />
          </ActionIcon>
        </Group>
        <Text size="sm" fw={600}>
          {firearmName}
        </Text>
        <Text size="xs" c="dimmed">
          Showing videos linked to this firearm. Click the X to clear filter.
        </Text>
      </Stack>
    </Box>
  )
}

export default SlopFeedFilterPanel
